import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bbe9d566")

_pushScopeId("data-v-bbe9d566")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-lg-4 col-md-6 col-sm-12 login-form" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-md-center" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 mb-5" }, "Reset Your Password")
], -1)
const _hoisted_6 = { class: "row justify-content-md-center" }
const _hoisted_7 = { class: "col-lg-8 col-md-10 col-sm-12" }
const _hoisted_8 = { class: "form-group text-left" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_14 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_15 = { class: "form-group text-left" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = {
  key: 0,
  class: "form-group text-left"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-8" }, [
    /*#__PURE__*/_createVNode("button", {
      type: "submit",
      class: "btn btn-block btn-primary form-control"
    }, " Reset ")
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheBanner = _resolveComponent("TheBanner")
  const _component_Password = _resolveComponent("Password")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_TheBanner),
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["stop","prevent"]))
            }, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Password, {
                  style: {"width":"100%"},
                  inputStyle: "width:100%",
                  toggleMask: "",
                  feedback: false,
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$v.password.$touch())),
                  placeholder: "Enter New Password"
                }, null, 8, ["modelValue"]),
                (_ctx.$v.password.$error)
                  ? (_openBlock(), _createBlock("small", _hoisted_9, _toDisplayString(_ctx.$v.password.$errors[0].$message), 1))
                  : _createCommentVNode("", true),
                (
                    _ctx.$v.password.$error && _ctx.$v.password.$errors[0].$message == ''
                  )
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      (_ctx.$v.password.containsUppercase.$invalid)
                        ? (_openBlock(), _createBlock("small", _hoisted_11, "An uppercase value is required"))
                        : (_ctx.$v.password.containsLowercase.$invalid)
                          ? (_openBlock(), _createBlock("small", _hoisted_12, "An lowercase value is required"))
                          : (_ctx.$v.password.containsNumber.$invalid)
                            ? (_openBlock(), _createBlock("small", _hoisted_13, "An number value is required"))
                            : (_ctx.$v.password.containsSpecial.$invalid)
                              ? (_openBlock(), _createBlock("small", _hoisted_14, "An special value (#?!@$%^&*-) is required"))
                              : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_Password, {
                  style: {"width":"100%"},
                  inputStyle: "width:100%",
                  toggleMask: "",
                  feedback: false,
                  modelValue: _ctx.confirm,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirm = $event)),
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$v.confirm.$touch())),
                  placeholder: "Repeat Password"
                }, null, 8, ["modelValue"]),
                (_ctx.$v.confirm.$error)
                  ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.$v.confirm.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isCodeRequired)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _withDirectives(_createVNode("input", {
                      id: "code",
                      required: "",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.code = $event)),
                      placeholder: "Two-Factor Authenticator"
                    }, null, 512), [
                      [_vModelText, _ctx.code]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_18
            ], 32)
          ])
        ])
      ])
    ]),
    _hoisted_19
  ]))
})